import * as Yup from "yup";
import { DynamicUpdateProfileFieldsConfig } from "./types";

type FieldConfig = {
  initialValue: any;
  validation: Yup.AnySchema;
  enabled: boolean;
  mandatory: boolean;
};

export const buildDynamicFormConfig = (
  data: DynamicUpdateProfileFieldsConfig,
  t
): Record<string, FieldConfig> => ({
  fullname: {
    initialValue: "",
    validation: Yup.string().min(3, t("signUp:min3Characters")).required(),
    enabled: data?.fullname?.enabled ?? false,
    mandatory: data?.fullname?.mandatory ?? false
  },
  firstname: {
    initialValue: "",
    validation: Yup.string().required("First name is required"),
    enabled: data?.firstname?.enabled ?? false,
    mandatory: data?.firstname?.mandatory ?? false
  },
  email: {
    initialValue: data?.initialEmail ?? "",
    validation: Yup.string()
      .email("Invalid email")
      .required("Email is required"),
    enabled: data?.email?.enabled ?? false,
    mandatory: data?.email?.mandatory ?? false
  },
  phone: {
    initialValue: data?.initialPhone ?? "",
    validation: Yup.string()
      .test(
        "is-valid-length",
        () =>
          `Phone number must be ${data.acceptablePhoneLengths?.join?.(
            " or "
          )} characters long.`,
        value =>
          value?.length && data.acceptablePhoneLengths.includes(value.length)
      )
      .required(),
    enabled: data?.phone?.enabled ?? false,
    mandatory: data?.phone?.mandatory ?? false
  },
  areaCode: {
    initialValue: data?.initialArea ?? "",
    validation: Yup.string(),
    enabled: data?.phone?.enabled ?? false,
    mandatory: (data?.initialArea && data?.phone?.mandatory) ?? false
  },
  countryCode: {
    initialValue: data?.initialCountryCode ?? "",
    validation: Yup.string(),
    enabled: data?.phone?.enabled ?? false,
    mandatory: data?.phone?.mandatory ?? false
  },
  nationality: {
    initialValue: "",
    validation: Yup.string().required(),
    enabled: data?.nationality?.enabled ?? false,
    mandatory: data?.nationality?.mandatory ?? false
  },
  gender: {
    initialValue: "",
    validation: Yup.string().required("Gender is required"),
    enabled: data?.gender?.enabled ?? false,
    mandatory: data?.gender?.mandatory ?? false
  },
  ...(data.showGuestRegistrationFields && {
    password: {
      initialValue: "",
      validation: Yup.string().min(8).max(32).trim().required(),
      enabled: true,
      mandatory: true
    },
    isAgeVerified: {
      initialValue: false,
      validation: Yup.boolean().oneOf([true], "Please verify your age"),
      enabled: true,
      mandatory: true
    }
  }),
  isNewsLetter: {
    initialValue: true,
    validation: Yup.boolean().notRequired(),
    enabled: true,
    mandatory: false
  },
  isLoyaltyProgramChecked: {
    initialValue: true,
    validation: Yup.boolean().oneOf([true], "Must accept loyalty terms"),
    enabled: true,
    mandatory: true
  }
});
